import { FIELDS } from './constants';

const defaultFields = [
  {
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  
  {
    key: 'id',
    field: FIELDS.ID,
    title: 'Id',
    label: 'id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'name',
    field: FIELDS.NAME,
    title: 'Name',
    label: 'name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'createdByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: 'Created By User Id',
    label: 'createdByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'modifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: 'Modified By User Id',
    label: 'modifiedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateCreated',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'dateCreated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateModified',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'dateModified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'active',
    sortable: true,
    hidden: false,
    width: 150,
  },
]

export default defaultFields;
